module.exports = __webpack_public_path__ + "img/рз_29.65fd48be.png";